<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html lang="en">
<head>
  <style>
    table, th, td {
      border: 1px solid grey;
      border-collapse: collapse;
      padding: 5px;
    }

    /*table tr:last-child {
        font-weight: bold;
      }*/

    table {
      table-layout: auto;
      width: auto !important;
      font-size: small;
    }
  </style>
  <!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/5.2.0/css/bootstrap.min.css" />
  <link rel="stylesheet" href="https://cdn.datatables.net/1.13.4/css/dataTables.bootstrap5.min.css" />-->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@3.0.0-alpha2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-aFq/bzH65dt+w6FI2ooMVUpc+21e0SRygnTpmBvdBgSdnuTN7QbdgL+OapgHtvPp" crossorigin="anonymous" />
  <script src="https://cdn.jsdelivr.net/npm/sweetalert2@11.10.6/dist/sweetalert2.all.min.js"></script>
  <link href="https://cdn.jsdelivr.net/npm/sweetalert2@11.10.6/dist/sweetalert2.min.css" rel="stylesheet" />
</head>
<body>
  <div class="container">
    <div id="pdfContent" #pdfContent>
      <h3>Delete Opening Dues (Individual)</h3><br />
      <!--<mat-radio-group [(ngModel)]="selectedRow" (change)="radioSelected($event)">
    <mat-radio-button [value]="1">Morning</mat-radio-button>
    <mat-radio-button [value]="2">Evening</mat-radio-button>
  </mat-radio-group>-->
      
      <mat-form-field appearance="standard">
        <label><b>Enter Enrolment No.</b></label>
        <input matInput=matInput style="font-size:20px;font-weight:bold" (change)="applyFilterSNE($event)" placeholder="" #input />
      </mat-form-field>
      <br />
      <!--<img src="https://www.freepnglogos.com/uploads/peacock-png/peacock-png-design-deviantart-2.png">-->
      <table id="data" class="table table-bordered" cellspacing="0" style="width:100%">
        <tr>
          <th> Enrolment No.</th>
          <th> Student Name</th>
          <th> Course</th>
          <th> Creation Date</th>
          <th> Head</th>
          <th> Amount</th>
          <th> Action</th>
        </tr>
        <tr *ngFor="let feedet of duesdetails | filter:searchText | paginate: { itemsPerPage: 16, currentPage: p, totalItems: total }; let i=index">
          <td>{{feedet.admno}}</td>
          <td> {{ feedet.studentName }}</td>
          <td width="50%">{{ feedet.course }}</td>
          <td>{{ feedet.createdDate | date:'dd-MM-yyyy'}}</td>
          <td>{{ feedet.headName }}</td>
          <td>{{ feedet.duesamt }}</td>
          <td *ngIf="feedet.admno != NULL"><button style="background-color: red; color: white; border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;" tabindex="3" type="submit" name="deletefee" (click)="DeleteDuesCreated(feedet.tId,feedet.yearCode,feedet.admno)">Delete</button></td>
        </tr>
      </table>
    </div>      
      <!--<pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>-->    
    <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js" integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj" crossorigin="anonymous"></script>
    <script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js" integrity="sha384-9/reFTGAW83EW2RDu2S0VKaIzap3H66lZH81PoYlFhbGU+6BZp6G7niu735Sk7lN" crossorigin="anonymous"></script>
    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js" integrity="sha384-B4gt1jrGC7Jh4AgTPSdUtOBvfO8shuf57BaghqFfPlYxofvL8/KUEfYiJOMMV+rV" crossorigin="anonymous"></script>
  </div>  
</body>
</html>
